import { forwardRef } from 'react';
import PropTypes from 'prop-types';

export const IconPause = forwardRef(
	({ color = 'currentColor', size = 24, ...rest }, ref) => {
		return (
			<svg
				ref={ref}
				xmlns="http://www.w3.org/2000/svg"
				width={size}
				height={size}
				viewBox="0 0 24 24"
				fill={color}
				stroke={color}
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				{...rest}>
				<rect x="6" y="4" width="4" height="16" />
				<rect x="14" y="4" width="4" height="16" />
			</svg>
		);
	}
);

IconPause.propTypes = {
	color: PropTypes.string,
	size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

IconPause.displayName = 'IconPause';